/**
 * @author Hideo Yamada
 * @description https://marvelapp.com/4g4b5dg/screen/58400534
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { find, isNil, propEq, values } from 'ramda';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Filter from '@components/@core/Filter';
import Pagination from '@components/@core/Pagination';
import * as CertificationCard from '@components/Certification';
import { DevelopActions } from '~/actions';
import withNavigate from '~/hocs/withNavigate';

class CertificationDetail extends Component {
    constructor(props) {
        super(props);

        const userId = Number(props.params?.userId || 0);
        const certId = Number(props.params?.id || 0);

        const { users, templates } = props;
        const program = find(propEq('id', certId), templates.certifications.data) || {};

        const userDetails = userId ? find(propEq('id', userId), users) : {};
        const profile = userId ? { ...userDetails.profile, id: userId } : null;

        this.state = { profile, program, contentLevel: program.level };
    }

    handleComplete = () => {
        const { program } = this.state;
        this.props.programPromote({ programId: program.id, route: '/hcm/report-certifications' });
    };

    handleContentPagination = (contentLevel) => {
        this.setState({ contentLevel });
    };

    render() {
        const { program, profile, contentLevel } = this.state;
        const levels = program.data.levels || {};

        return (
            <ErrorBoundary className="manage-report-certification-detail overflow-hidden">
                <Filter back="Back" />
                <Row>
                    <Col xs={12} sm={6}>
                        <CertificationCard.Info title={program.title} description={program.data.description} icon={program.data.thumb_url} />
                    </Col>
                    <Col xs={12} sm={6}>
                        <CertificationCard.Levels data={levels} />
                    </Col>
                </Row>
                {!isNil(profile) && (
                    <CertificationCard.User className="mt-3" userId={this.props.userId} profile={profile} certification={program} contentLevel={contentLevel} onComplete={this.handleComplete} />
                )}
                <CertificationCard.Requirements className="mt-3" contentLevel={contentLevel} data={levels} />
                <Pagination suffix="LEVEL" pers={[]} current={contentLevel} total={values(levels).length} onChange={(e) => this.setState({ contentLevel: e })} />
            </ErrorBoundary>
        );
    }
}

CertificationDetail.propTypes = {
    users: PropTypes.any,
    userId: PropTypes.number,
    templates: PropTypes.any,
};

CertificationDetail.defaultProps = {
    users: [],
    userId: 0,
    templates: {},
};

const mapStateToProps = (state) => ({
    users: state.app.users,
    userId: state.app.id,
    templates: state.develop.templates,
});

const mapDispatchToProps = (dispatch) => ({
    programPromote: (e) => dispatch(DevelopActions.programpromotionRequest(e)),
});

const CertificationDetailWithNavigate = withNavigate(connect(mapStateToProps, mapDispatchToProps)(CertificationDetail));
export default CertificationDetailWithNavigate;
